module.exports = __webpack_public_path__ + "static/media/rule-book-cover.f4d3beec.png";